import styled from "styled-components";
import Modal from "react-modal";
import Button from "../Buttons";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const CancelTicketModal = ({
  isCancelTicket,
  closeTicketModal,
  manageTextinput,
  onCancelTicket,
  reasonText,
}) => {
  return (
    <Modal
      isOpen={isCancelTicket}
      onRequestClose={closeTicketModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          maxHeight: "18rem",
          maxWidth: "25rem",
          margin: "auto",
          display: "flex",
          paddingBottom: "2rem",
          zIndex: 9999,
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.15)",
          zIndex: 999,
        },
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }} >
        <TextInputContainer>
          <MainText>{Text.cancelText}</MainText>
          <SubText>{Text.cancelSubText}</SubText>
          <InputContainer>
            <InputTitle>
              {Text.reasonTitleText}
              <span>*</span>
            </InputTitle>
            <TextInput
              rows={4}
              placeholder="Enter the reason"
              onChange={(value) => manageTextinput(value)}
            />
          </InputContainer>
          <ButtonContainer>
            <Button
              variant="outlined"
              label="Close"
              onClick={closeTicketModal}
              width="45%"
              backgroundColor={Colors.white}
              size="large"
              fontColor={Colors.red}
              padding={"0.5rem 0.5rem"}
            />
            <Button
              label="Confirm"
              variant="filled"
              padding="0.4rem 1.25rem"
              width="45%"
              onClick={() => onCancelTicket(reasonText)}
              disabled={reasonText === ""}
            />
          </ButtonContainer>
        </TextInputContainer>
      </div>
    </Modal>
  );
};

export default CancelTicketModal;

const TextInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 0.5rem;
`;
const MainText = styled.span`
  color: ${Colors.darkishBlue};
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  @media only screen and (max-width: 414px) {
    font-size: 1rem;
  }
`;
const SubText = styled(MainText)`
  color: #e8aa28;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 400;
  width: 80%;
  margin-top: 0.5rem;
  @media only screen and (max-width: 414px) {
    font-size: 0.7rem;
    width: 90%;
  }
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  align-self: flex-start;
  padding-left: 1.2rem;
  width: 90%;
`;
const InputTitle = styled.span`
  color: ${Colors.darkishBlue};
  font-size: 0.9rem;
  font-weight: 500;
  @media only screen and (max-width: 414px) {
    font-size: 0.8rem;
  }

  span {
    color: ${Colors.red};
  }
`;
const TextInput = styled.textarea`
  margin-top: 0.5rem;
  border-radius: 8px;
  padding: 0.5rem;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  width: 90%;
  justify-content: space-between;
  @media only screen and (max-width: 414px) {
    margin-top: 1.5rem;
  }
`;
